import React, { useState } from "react";
import "./Gallery.css";

// Import local images from src/assets
import photo1 from "../assets/IMG_20250407_185631.jpg";
import photo2 from "../assets/IMG_20250407_185646.jpg";
import photo3 from "../assets/IMG_20250407_185703.jpg";
import photo4 from "../assets/IMG_20250407_185930.jpg";
import photo5 from "../assets/IMG_20250407_190141.jpg";
import photo6 from "../assets/IMG_20251215_183517.png";
import photo7 from "../assets/Screenshot_2025_1215_183220.png";      
import photo8 from "../assets/Screenshot_2025_1215_183233.png";
import photo9 from "../assets/Screenshot_2025_1215_183253.png";
import photo10 from "../assets/Screenshot_2025_1215_183324.png";
import photo11 from "../assets/Screenshot_2025_1215_183338.png";

export default function Gallery() {
  const [activeTab, setActiveTab] = useState("photos");

  // Photo data
  const photos = [photo1, photo2, photo3, photo4, photo5, photo6, photo7, photo8, photo9, photo10, photo11];

  // Video data (YouTube links)
  const videos = [
    "",
    "",
  ];

  return (
    <div className="gallery-page">

      {/* Toggle Tabs */}
      <div className="gallery-toggle">
        <div
          className={`toggle-button ${activeTab === "photos" ? "active" : ""}`}
          onClick={() => setActiveTab("photos")}
        >
          Photos
        </div>
        <div
          className={`toggle-button ${activeTab === "videos" ? "active" : ""}`}
          onClick={() => setActiveTab("videos")}
        >
          Videos
        </div>

        {/* Animated indicator */}
        <div className={`toggle-indicator ${activeTab}`}></div>
      </div>

      {/* Gallery Content */}
      <div className="gallery-content">
        {activeTab === "photos" && (
          <div className="photo-grid">
            {photos.map((src, idx) => (
              <img key={idx} src={src} alt={`Gallery ${idx + 1}`} />
            ))}
          </div>
        )}

        {activeTab === "videos" && (
          <div className="video-grid">
            {videos.map((link, idx) => (
              <div className="video-wrapper" key={idx}>
                <iframe
                  width="100%"
                  height="315"
                  src={link}
                  title={`Video ${idx + 1}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
